/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormEditCreateUpdateDateTimeFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/datetime/create-update/form-edit-create-update-datetime-field-dialog.component';
/* eslint-enable */

/**
 * Date field implementation.
 */
export class FormEditDateTimeFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdateDateTimeFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateDateTimeFieldDialogComponent)
      .create(this.injector);
  }

}
